<template>
  <div>
    Minimum number of satellites to be seen by any point on the Earth at any
    given moment.
  </div>
</template>

<script>
export default {
  name: 'tooltipConstellationGeometryCoverageLevel'
}
</script>
